import { StockItemAllocation } from './stock-item-allocation';

export interface ProductStockAllocations {
  id: string;
  productKey: string;
  productDescription: string;
  productType: string;
  allocations: StockItemAllocation[];
}
